import { useSearchParamsToReducer } from "../hooks/useSearchParamsToReducer";
import { SearchFilter } from "./SearchFilter";

type Props = {
	searchData: Function;
};

export const Filters = ({ searchData }: Props) => {
	useSearchParamsToReducer({ searchData });

	return (
		<>
			<SearchFilter />
		</>
	);
};
